<template>
    <div class="container-fluid">
        <br>
        <p class="text-header">LAND INFORMATION</p>
       
        <div class="account-details">
            <div class="table table-responsive">
                <div class="contract-header">
                    <div> <span class="badge badge-primary">{{ modelCount }}</span> LAND(S) </div>
                    <div><button @click="createLand">Register Land</button></div>
                </div>
    
                <div class="table table-responsive table-sm">
                    <div class="mb-3">
                    <input 
                        type="text" 
                        class="form-control"
                        placeholder="Search..."
                        v-model="search"
                    />
                    </div>

                    <v-data-table
                        :headers="header"
                        :items="desserts"
                        dense
                        :search="search"
                        class="table-striped table-bordered table-responsive farmer-table"
                        >
                        <template v-slot:item.action="{ item }">
                            <div class="d-flex flex-row">
                                <button @click="viewMap(item.gps_location)" class="btn btn-primary btn-sm" style="font-size:12px;">
                                View Map 
                                </button>
                            </div>
                        </template> 
                    </v-data-table>
                </div>
            </div>
        </div>

         <!-- ===================== CREATE LAND ====================== -->
        <div v-if="createLandModel" class="modal-backdrop-custom">
        <div class="modal-wrapper">
            <div class="modal-subs modal-lg shadow-lg rounded-3 overflow-hidden bg-white">

            <!-- Header -->
            <div class="modal-header subs-content text-white">
                <h5 class="modal-title">
                <i class="bi bi-geo-alt"></i> Create Land
                </h5>
                <button type="button" class="btn-close btn-close-white" @click="closeModal"></button>
            </div>

            <!-- Body -->
            <div class="modal-body p-4 modal-body-scroll ">

                <!-- Toggle Buttons -->
                <div class="mb-4 text-center">
                <button
                    class="btn"
                    :class="isBulk ? 'btn-outline-primary' : 'btn-primary'"
                    @click="isBulk = false">
                    Single Land
                </button>
                </div>

                <!-- ===================== SINGLE LAND FORM ====================== -->
                <div v-if="!isBulk">
                    <div class="user-info px-3">
                        <div class="row">

                        <!-- STATE -->
                        <div class="col-md-4 mb-3">
                            <label class="text-muted">State</label>
                            <select class="form-control" v-model="state">
                            <option value="">Select State</option>
                            <option v-for="s in states" :key="s" :value="s">
                                {{ s }}
                            </option>
                            </select>
                        </div>

                        <!-- LGA -->
                        <div class="col-md-4 mb-3">
                            <label class="text-muted">LGA</label>
                            <input type="text" class="form-control"
                            v-model="lga" placeholder="Enter LGA">
                        </div>

                        <!-- CITY -->
                        <div class="col-md-4 mb-3">
                            <label class="text-muted">City / Town</label>
                            <input type="text" class="form-control"
                            v-model="city" placeholder="Enter city">
                        </div>

                        <!-- COMMUNITY -->
                        <div class="col-md-6 mb-3">
                            <label class="text-muted">Community</label>
                            <input type="text" class="form-control"
                            v-model="community"
                            placeholder="Enter community">
                        </div>

                        <!-- LAND SIZE -->
                        <div class="col-md-6 mb-3">
                            <label class="text-muted">Land Size (Hectares/Acres)</label>
                            <input type="text" class="form-control"
                            v-model="size"
                            placeholder="Enter land size">
                        </div>

                        <!-- GPS LOCATION -->
                        <div class="col-md-6 mb-3">
                        <label class="text-muted">GPS Location</label>
                        <div class="input-group">
                            <input type="text" class="form-control" v-model="gps_location" placeholder="Lat, Long" readonly>
                            <button class="btn btn-outline-primary" type="button" @click="getGPSLocation">
                            Get GPS
                            </button>
                        </div>
                        </div>

                        <!-- SUITABLE FOR -->
                        <div class="col-md-6 mb-3">
                            <label class="text-muted">Suitable For</label>
                            <input type="text" class="form-control"
                            v-model="suitable_for"
                            placeholder="Enter what's suitable for">
                        </div>

                        </div>
                    </div>
                </div>

                <!-- ===================== BULK UPLOAD ====================== -->
                <div v-if="isBulk" class="px-3">

                <div class="alert alert-info">
                    Upload Excel file for lands.<br>
                    <strong>Required Columns:</strong>
                    state, lga, city, cooperative, community, size, gps_location, suitable_for
                </div>

                <input
                    type="file"
                    accept=".xlsx, .xls"
                    class="form-control mb-3"
                    @change="handleBulkFile"
                >

                <button class="btn btn-primary" @click="uploadBulkLands">
                    Upload Excel
                </button>

                </div>

            </div>

            <!-- Footer -->
            <div class="modal-footer d-flex justify-content-end bg-light px-4">
                <button
                type="button"
                class="btn btn-outline-secondary px-4 me-2"
                @click="closeModal">
                Cancel
                </button>

                <button
                type="button"
                class="btn btn-success px-4"
                @click="submitLand">
                Submit
                </button>
            </div>

            </div>
        </div>
        </div>

        <!-- Map Modal -->
        <div v-if="showMapModal" class="modal-backdrop-custom">
        <div class="modal-wrapper">
            <div class="modal-subs modal-lg shadow-lg rounded-3 overflow-hidden bg-white">
            
            <div class="modal-header subs-content text-white">
                <h5 class="modal-title">
                <i class="bi bi-geo-alt"></i> Land Location
                </h5>
                <button type="button" class="btn-close btn-close-white" @click="showMapModal = false"></button>
            </div>

            <div class="modal-body p-4 modal-body-scroll ">
                <iframe
                :src="googleMapUrl"
                width="100%"
                height="450"
                style="border:0;"
                allowfullscreen=""
                loading="lazy">
                </iframe>

            </div>

            <div class="modal-footer d-flex justify-content-end bg-light px-4">
                <button type="button" class="btn btn-outline-secondary px-4 me-2" @click="showMapModal = false">
                Close
                </button>
            </div>
            </div>
        </div>
        </div>


        <p>&nbsp;</p>
        <page-loader :is-loading="isLoading"></page-loader>
    </div>
    </template>
    
      
    <script>
    //import swal from 'sweetalert2';
    import PageLoader from '../components/PageLoader.vue'
    import * as XLSX from "xlsx";
    import L from "leaflet";

    export default {
    
        name: "AllUsersPage",
        components: {
            //quillEditor,
            PageLoader,
        },
    
        data() {
            return {
    
                isLoading: false,
                loading: false,
                loading1: false,
                loading2: false,
                loading3: false,
                role_type: '',
                
                editorOptions: {
                    placeholder: 'Write something...',
                },
    
                img_url: process.env.VUE_APP_IMAGE_URL,
                search: "",
                header: [

                    {
                        value: 'community',
                        text: 'Community'
                    },
                    {
                        value: 'lga',
                        text: 'LGA'
                    },
                    {
                        value: 'city',
                        text: 'City/Town'
                    },
                    {
                        value: 'state',
                        text: 'State'
                    },
                    {
                        value: 'size',
                        text: 'Size'
                    },
                    {
                        value: 'suitable_for',
                        text: 'Suitable For'
                    },
                    {
                        value: 'gps_location',
                        text: 'GPS Location'
                    },
                    {
                        value: 'action',
                        text: 'Action'
                    },
                    
                ],
    
                desserts: [],
                user_role: '',
                createLandModel: false,
                state: '',
                lga: '',
                city: '',
                cooperative: '',
                community: '',
                size: '',
                gps_location: '',
                suitable_for: '',
                agent: '',
               
                states: [
                    'Abia','Adamawa','Akwa Ibom','Anambra','Bauchi','Bayelsa',
                    'Benue','Borno','Cross River','Delta','Ebonyi','Edo',
                    'Ekiti','Enugu','FCT','Gombe','Imo','Jigawa','Kaduna',
                    'Kano','Katsina','Kebbi','Kogi','Kwara','Lagos','Nasarawa',
                    'Niger','Ogun','Ondo','Osun','Oyo','Plateau','Rivers',
                    'Sokoto','Taraba','Yobe','Zamfara'
                ],


                isBulk: false,
                bulkFile: null,
                roles: '',
                modelData: [],
                modelCount: 0,
                showMapModal: false,
                map: null,
                mapLocation: "", // will store GPS as "lat, long"
                googleMapUrl: ''

            };
        },
    
        beforeMount() {
    
        },
    
        async mounted() {
    
            this.createdBy = localStorage.getItem("username");
            this.user_id = localStorage.getItem("userid");
            this.roles = localStorage.getItem("roles");
            this.getGPSLocation();
            await this.fetchAllLands()
        },
    
        created() {
    
        },
    
        computed: {

            indexSn() {
                return this.desserts.map((d, index) => ({
                    ...d,
                    sn: index + 1
                }))
            },
    
        },
    
        methods: {
            openMapModal(gps) {
            if (!gps) {
                alert("No GPS location available for this land.");
                return;
            }

            this.mapLocation = gps;
            this.showMapModal = true;

            this.$nextTick(() => {
                const [lat, lng] = this.mapLocation.split(",").map(Number);

                if (this.map) {
                this.map.remove(); // Remove old map instance if exists
                }

                this.map = L.map("map").setView([lat, lng], 15);

                L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
                attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
                }).addTo(this.map);

                L.marker([lat, lng]).addTo(this.map)
                .bindPopup("Land Location")
                .openPopup();
            });
            },
            viewMap(gps) {
                if (!gps) return alert("No GPS location available.");
                this.gpsLocation = gps;

                const [lat, lng] = gps.split(",");
                this.googleMapUrl = `https://www.google.com/maps?q=${lat},${lng}&hl=es;z=15&output=embed`;
                this.showMapModal = true;
            },
            getGPSLocation() {
            if (!navigator.geolocation) {
                console.log("Geolocation not supported");
                alert("Geolocation not supported");
                return;
            }

            navigator.geolocation.getCurrentPosition(
                (position) => {
                    console.log("Latitude:", position.coords.latitude);
                    console.log("Longitude:", position.coords.longitude);
                    const lat = position.coords.latitude;
                    const long = position.coords.longitude;
                    this.gps_location = `${lat}, ${long}`;
                },
                (error) => {
                switch (error.code) {
                    case 1:
                    console.error("Permission denied");
                    alert("Permission denied");
                    break;
                    case 2:
                    alert("Position unavailable");
                    console.error("Position unavailable");
                    break;
                    case 3:
                    alert("Request timeout");
                    console.error("Request timeout");
                    break;
                    default:
                    alert("Unknown error");
                    console.error("Unknown error");
                }
                },
                {
                enableHighAccuracy: true,
                timeout: 15000,
                maximumAge: 0
                }
            );
            },
            // getGPSLocation() {
            //     if (navigator.geolocation) {
            //     navigator.geolocation.getCurrentPosition(
            //         position => {
            //         const lat = position.coords.latitude;
            //         const long = position.coords.longitude;
            //         this.gps_location = `${lat}, ${long}`;
            //         },
            //         error => {
            //         console.error("Error getting location:", error);
            //         alert("Unable to get GPS location. Please allow location access.");
            //         }
            //     );
            //     } else {
            //     alert("Geolocation is not supported by this browser.");
            //     }
            // },
            validateNumber() {
            const value = this.delivery_period;
            if (value < 0) {
              this.error = 'Value must be non-negative';
              this.delivery_period = ''
              return
            } else if (!Number.isInteger(Number(value))) {
              this.error = 'Value must be an integer';
              this.delivery_period = ''
              return
            } else {
              this.error = '';
            }
          },
    
            formatToCurrency(value) {
              return value.toLocaleString('en-NG', { minimumFractionDigits: 2 })
            },
    
           
            copied(){
                this.isContractLink = false
            },
    
            copyToClipboard(link) {
               // var copyText = document.getElementById("myInput");
                navigator.clipboard.writeText(link).then(function() {
                    alert("Contract link copied to clipboard!");
                }).catch(function(err) {
                    console.error('Failed to copy: ', err);
                });
            },
    
            copyToClipboard1(link) {
               // var copyText = document.getElementById("myInput");
                navigator.clipboard.writeText(link).then(function() {
                    alert("Contract link copied to clipboard!");
                }).catch(function(err) {
                    console.error('Failed to copy: ', err);
                });
            },
            async submitLand() {
                try {
                    // Check if GPS location is obtained
                if (!this.gps_location) {
                try {
                    await this.getGPSLocation();
                } catch {
                    return; // Stop submission if GPS not allowed
                }
                }
                const response = await this.$http.post("/land/create", {
                    community: this.community,
                    lga: this.lga,
                    city: this.city,
                    state: this.state,
                    size: this.size,
                    suitable_for: this.suitable_for,
                    gps_location: this.gps_location,
                    createdBy: this.createdBy,
                });
                    alert(
                        `Land created successfully!`
                    );
                    this.fetchAllLands()
                    this.closeModal();

                } catch (err) {
                    
                    console.error(err);
                    alert(err.response ? err.response.data.message : err.message)
                }
            },

            handleBulkFile(event) {
            const file = event.target.files[0];
            if (!file) return;

            const fileName = file.name.toLowerCase();

            // Check by extension
            if (!fileName.endsWith(".xlsx") && !fileName.endsWith(".xls")) {
                this.$toast.error("Invalid file type. Please upload an Excel file (.xlsx or .xls)");
                return;
            }

            const reader = new FileReader();

            reader.onload = (e) => {
                const data = new Uint8Array(e.target.result);
                const workbook = XLSX.read(data, { type: "array" });

                const sheetName = workbook.SheetNames[0];
                const sheet = workbook.Sheets[sheetName];

                // Convert Excel sheet to JSON
                let json = XLSX.utils.sheet_to_json(sheet, { defval: "" });

                // Append username to every row
                json = json.map(row => ({
                ...row,
                username: this.username
                }));

                this.bulkFile = json; // Now bulkFile is an array of customer objects
                this.$toast.success("File loaded successfully!");
            };

            reader.readAsArrayBuffer(file);
            },

            async uploadBulkFarmers() {
            if (!this.bulkFile || this.bulkFile.length === 0) {
                this.$toast.error("Please select an Excel file and load it first");
                return;
            }

            try {
                // Send the parsed JSON array directly
                const res = await this.$http.post("/farmers/create-bulk", this.bulkFile);

                if (res.data.status === "00") {
                this.$toast.success("Farmers uploaded successfully!");
                // Optionally, clear the file after upload
                this.bulkFile = [];
                } else if (res.data.errors && res.data.errors.length > 0) {
                // Show the first error message
                this.$toast.error(res.data.errors[0]?.message || res.data.message);
                } else {
                this.$toast.error(res.data.message || "Bulk upload failed");
                }
            } catch (err) {
                console.error(err);
                this.$toast.error("Bulk upload failed due to network or server error");
            }
            },

            async fetchAllLands() {
                try {
                    this.isLoading = true
                    this.desserts = []
                    const response = await this.$http.get(`/land/fetch-all`, {

                    })
                    this.isLoading = false
                    
                    this.modelData = response.data.data
                    this.modelCount = this.modelData.length
                    this.modelData.forEach(el => {
                        this.desserts.push({
                            landId: el.landId,
                            community: el.community,
                            lga: el.lga,
                            city: el.city,
                            state: el.state,
                            size: el.size,
                            suitable_for: el.suitable_for,
                            gps_location: el.gps_location

                        })
                    });
    
                } catch (err) {
                    alert(err.response ? err.response.data.message : err.message)
                    this.isLoading = false
                    //this.$router.push('/home')
                    console.log(err);
                }
            },

            createLand() {
                this.createLandModel = true;
            },
            closeModal() {
                this.createLandModel = false;
            },
    
        }
    
    }
    </script>
      
    <style lang="scss" scoped>
    @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;700&display=swap');
    #map {
        height: 400px;
        width: 100%;
    }
    .farmer-table {
      font-size: 12px !important;
    }

    .farmer-table .v-data-table-header th {
      font-size: 12px !important;
    }

    .farmer-table tbody td {
      font-size: 12px !important;
    }

    /* Backdrop */
    .modal-backdrop-custom {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.65);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1050;
    }

    /* Modal wrapper (center container) */
    .modal-wrapper {
    width: 100%;
    max-width: 600px;
    }

    /* Header */
    .subs-content {
    padding: 0.5rem;
    background-color: #D33E74; /* Bootstrap success green */
    }
    .btn-success{
        background-color: #D33E74; 
        border: 0px;
    }
    .btn-xs{
        padding: 0.2rem;
        border: 0px;
        font-family: Poppins;
        font-size: 12px;
        font-weight: 500;
    }
    .modal-footer{
        padding: 0.5rem;
    }
    /* User info */
    .user-info p {
    font-size: 1rem;
    color: #222;
    border-bottom: 1px solid #f1f1f1;
    padding-bottom: 8px;
    }
    .user-info p:last-child {
    border-bottom: none;
    }

    .user-info strong {
  display: block;
  font-size: 0.9rem;
  margin-bottom: 4px;
  color: #6c757d;
}
.user-info div {
  font-size: 1rem;
  color: #212529;
  font-weight: 500;
}

    .error {
        color: #fff;
      }
      .error1 {
        color: #fff;
      }
    .quill-container {
        height: 200px;
        /* Set the desired height here */
    }
    .copy-refid{
        cursor: pointer;
        font-size: 16px;
    }
    .copy-refid1{
        cursor: pointer;
        font-size: 15px;
        font-weight: 600;
    }
    .a-text {
        font-size: 12px;
        font-family: Poppins;
    }
    .a-text1 {
        font-size: 14px;
        font-family: Poppins;
    }
    .process-payment{
        cursor:pointer;
    
    }
    label {
        font-size: 12px;
        font-family: Poppins;
        font-weight: normal;
    }
    
    .inputs {
        margin-top: 20px;
        border-radius: 3px;
        font-size: 12px;
    }
    
    .price-fee {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
    
        div {
            margin: 4px;
            width: 100%;
    
        }
    }
    
    .adjust-fee-input {
        // width: 100px;
        text-align: center;
    }
    
    .whopays-fee-input {
        //width: 100% !important;
    }
    
    .shop-detail {
        font-size: 12px;
        font-family: Poppins;
    }
    
    .btn-danger {
        text-transform: uppercase;
        font-size: 13px;
        font-family: Poppins;
        background: #D33E74;
        border: 0px;
        height: 45px;
    }
    
    .text-header {
        padding: 0.5rem;
        font-size: 14px;
        font-weight: bold;
        font-family: Poppins;
        background: #ccc;
    }
    
    .contract-header {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        background: #D33E74;
        color: #fff;
        border-radius: 4px;
        padding: 0.8rem;
        font-size: 14px;
        font-weight: 700;
        font-family: Poppins;
        margin-bottom: 5px;
    }
    
    .welcome {
        font-family: Poppins;
        font-size: 20px;
        font-weight: 700;
        margin-top: 15px;
        color: #170e0fac;
    }
    
    .account-details {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        border-radius: 4px;
        //padding: 0.9rem;
        background: #fff;
        width: 100%;
    }
    
    .account-balance {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        background: #780712;
        color: #fff;
        width: 100%;
        height: 100%;
        border-radius: 10px;
        font-family: Poppins;
        padding: 0.4rem;
        padding-left: 2rem;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    }
    
    .wallet-detail {
        padding-top: 1rem;
        line-height: 1.4px;
        font-size: 15px;
    
        h4 {
            font-weight: 650;
        }
    
        .acct-d {
            line-height: 0.8;
            cursor: pointer;
            text-decoration: underline;
        }
    }
    
    .wallet-icon {
        font-size: 60px
    }
    
    .fund-account {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        background: #076378;
        color: #fff;
        width: 100%;
        height: 100%;
        border-radius: 10px;
        font-family: Poppins;
        padding: 0.4rem;
        padding-left: 2rem;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    }
    
    .inputs-field {
        font-size: 14px;
        font-family: Poppins;
        height: 45px;
    }
    
    .content-center {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        border: solid 1px #170e0fac;
        border-radius: 4px;
        padding: 0.5rem;
        margin: 4px;
    }
    
    .box1 {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        border-radius: 10px;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
        font-family: Poppins;
    
        a {
            text-decoration: none;
            color: #000;
        }
    }
    
    .image-input {
        margin-top: 10px;
    }
    
    .box-icon {
        padding-left: 0.4rem;
        font-size: 35px;
        color: #637807;
    }
    
    .box-details {
        font-size: 14px;
        color: #170e0fac;
    }
    
    .box1:hover {
        transform: scale(1.1);
        transition: transform 0.3s ease;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.3), 0 6px 20px 0 rgba(0, 0, 0, 0.24);
        cursor: pointer;
    }
    
    .box2 {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        border-radius: 10px;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
        font-family: Poppins;
    
        a {
            text-decoration: none;
            color: #000;
        }
    }
    
    .box2:hover {
        transform: scale(1.1);
        transition: transform 0.3s ease;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.3), 0 6px 20px 0 rgba(0, 0, 0, 0.24);
        cursor: pointer;
    }
    
    .box3 {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        border-radius: 10px;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
        font-family: Poppins;
    
        a {
            text-decoration: none;
            color: #000;
        }
    }
    
    .box3:hover {
        transform: scale(1.1);
        transition: transform 0.3s ease;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.3), 0 6px 20px 0 rgba(0, 0, 0, 0.24);
        cursor: pointer;
    }
    
    .box4 {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        border-radius: 10px;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
        font-family: Poppins;
    
        a {
            text-decoration: none;
            color: #000;
        }
    }
    
    .box4:hover {
        transform: scale(1.1);
        transition: transform 0.3s ease;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.3), 0 6px 20px 0 rgba(0, 0, 0, 0.24);
        cursor: pointer;
    }
    
    .box5 {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        border-radius: 10px;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
        font-family: Poppins;
    
        a {
            text-decoration: none;
            color: #000;
        }
    }
    
    .box5:hover {
        transform: scale(1.1);
        transition: transform 0.3s ease;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.3), 0 6px 20px 0 rgba(0, 0, 0, 0.24);
        cursor: pointer;
    }
    
    .box6 {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        border-radius: 10px;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
        font-family: Poppins;
    
        a {
            text-decoration: none;
            color: #000;
        }
    }
    
    .box6:hover {
        transform: scale(1.1);
        transition: transform 0.3s ease;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.3), 0 6px 20px 0 rgba(0, 0, 0, 0.24);
        cursor: pointer;
    }
    
    .img {
        border-top-right-radius: 10px;
        border-top-left-radius: 10px;
    }
    
    .box-details {
        padding: 0.4rem;
        line-height: 1.4px;
    
        .title {
            font-family: Poppins;
            font-weight: 550;
            font-size: 10px;
            text-transform: capitalize;
            color: #ff4d63;
        }
    
        .description {
            font-family: Poppins;
            font-size: 12px;
        }
    }
    
    .continue {
        display: flex;
        flex-direction: row;
        justify-content: right;
        padding-right: 0.4rem;
        font-size: 30px;
        color: rgb(237, 138, 108);
        margin-right: 10px;
        margin-top: -10px;
        margin-bottom: 10px;
    }
    
    .modal-mask {
        position: fixed;
        //z-index: 9998;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, .5);
        display: table;
        transition: opacity .4s ease;
    
        &>div {
            width: 90%;
            height: auto;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            background: #fff;
            ;
            backdrop-filter: blur(13px);
            border-radius: 10px;
            box-sizing: border-box;
            font-family: Poppins;
        }
    
        h3 {
            margin-top: 10px;
            font-size: 18px;
            color: #000;
            font-weight: bold;
            font-family: Poppins;
        }
    }
    
    .account-content {
        display: flex;
        flex-direction: column;
        justify-content: center;
    }
    
    .account-content-h {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 50px;
    
        padding-top: 1.3rem;
        text-transform: uppercase;
        text-align: center;
        //text-decoration: underline;
    }
    
    .add-fund {
        font-size: 12px;
        text-decoration: none !important;
        text-transform: capitalize;
    }
    
    .account-content-d {
        padding-top: 1.3rem;
        font-size: 14px;
        margin-bottom: 10px;
    }
    
    .btn-secondary {
        text-transform: uppercase;
    }
    
    .modal-close {
        color: #000;
        line-height: 50px;
        font-size: 140%;
        position: absolute;
        right: 0;
        text-align: center;
        top: 2;
        width: 70px;
        text-decoration: none;
    
        &:hover {
            color: black;
        }
    }
    
    .modal-close-mobile {
        color: #000;
        line-height: 50px;
        font-size: 140%;
        position: absolute;
        right: 0;
        text-align: center;
        top: 2;
        width: 70px;
        text-decoration: none;
    
        &:hover {
            color: black;
        }
    
        display: none;
    }
    
    a {
        text-decoration: none;
    }
    
    .shop-name {
        //font-weight: 550;
        color: #000;
        font-family: Poppins;
    }
     /* Scrollable Body */
     .modal-body-scroll {
        overflow-y: auto;
        max-height: calc(95vh - 130px);
        }
    @media screen and (max-width: 768px) {
        .modal-wrapper {
            padding: 20px;
        }
        .modal-subs {
            height: 95vh;
            border-radius: 12px;
        }

        .modal-body-scroll {
            max-height: calc(95vh - 120px);
            overflow-y: auto;
            -webkit-overflow-scrolling: touch; /* Smooth iOS scroll */
        }
        .copy-refid1{
            cursor: pointer;
            font-size: 14px;
            font-weight: 600;
        }
        .inputs-field {
            font-size: 12px;
            font-family: Poppins;
            font-weight: normal;
            height: 45px;
        }
        .contract-header {
    
            font-size: 12px !important;
    
        }
    
        .counter {
            font-size: 13px;
            font-weight: 500 !important;
        }
    
        .welcome {
            font-family: Poppins;
            font-size: 16px;
            font-weight: 700;
            text-align: left;
            color: #170e0fac;
        }
    
        .content-center {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            padding: 0.9rem;
        }
    
        .image-input {
            margin-top: 20px;
        }
    
        .price-fee {
            display: flex;
            flex-direction: column;
    
            div {
                width: 100%;
            }
        }
        .margin-mobile{
            margin-top: 90px;;
        }
    
        .adjust-fee-input {
            width: 100%;
        }
    
        .account-details {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            border-radius: 4px;
            width: 100%;
        }
    
        .account-balance {
            margin-bottom: 10px;
        }
    
        .box-details {
            padding: 0.4rem;
            line-height: 1.4px;
    
            .title {
                font-family: Poppins;
                font-weight: 550;
                font-size: 8px;
                text-transform: capitalize;
                color: #ff4d63;
            }
    
            .description {
                font-family: Poppins;
                font-size: 12px;
            }
        }
    
        .inputs {
            font-size: 12px;
        }
    
        .box1 {
            width: 100%;
            height: 100%;
            border-radius: 10px;
            margin-bottom: 10px;
        }
    
        .box2 {
            width: 100%;
            height: 100%;
            border-radius: 10px;
            margin-bottom: 10px;
        }
    
        .box3 {
            width: 100%;
            height: 100%;
            border-radius: 10px;
            margin-bottom: 10px;
        }
    
        .box4 {
            width: 100%;
            height: 100%;
            border-radius: 10px;
            margin-bottom: 10px;
        }
    
        .box5 {
            width: 100%;
            height: 100%;
            border-radius: 10px;
            margin-bottom: 10px;
        }
    
        .continue {
            display: flex;
            flex-direction: row;
            justify-content: right;
            padding-right: 0.4rem;
            font-size: 30px;
            margin-top: -10px;
            color: rgb(237, 138, 108);
        }
    
        .modal-close-mobile {
            display: block;
        }
    
        .modal-close {
            display: none;
        }
    
        .account-content {
            margin: 0px;
            margin-right: 0px;
        }
    
    }
    </style>
    